<template>
  <div
    id="milesNBonusOTP"
    class="modal s-modal-miles-n-bonus-otp"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content align-items-center">
        <Loader v-if="isLoading" display="absolute"></Loader>
        <div class="modal-header">
          <Alert
            v-if="errorMsgs.length"
            type="danger"
            :messages="errorMsgs"></Alert>
          <div class="modal-title" :class="{ 'wrong-code': wrongCode }">
            <i v-if="!wrongCode" class="icon-phone-checked"></i>
            <i v-else class="icon-phone-off"></i>
            <div v-if="!wrongCode">
              {{ mbDictionary.otpDefaultHeaderText }}
            </div>
            <div v-else>{{ mbDictionary.otpErrorHeaderText }}</div>
          </div>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="reset">
            <i class="icon-close-light"></i>
          </button>
        </div>
        <div class="modal-body alignt-center">
          <div
            v-if="!wrongCode"
            class="description mb-40"
            v-html="mbDictionary.otpDefaultDescriptionText"></div>
          <div
            v-else
            class="description mb-40"
            v-html="mbDictionary.otpErrorDescriptionText"></div>
          <form
            class="opt-form"
            autocomplete="off"
            @submit.prevent="onSubmitForm">
            <div
              class="otp-input-fields mb-32"
              :class="{ 'wrong-code': wrongCode }">
              <input
                v-for="(digit, index) in otpLength"
                :key="index"
                :ref="`otpInput${index}`"
                v-model="otpCodeArray[index]"
                class="otp-input-field"
                type="text"
                maxlength="1"
                required
                :disabled="wrongCode"
                @input="focusNextInput($event, index)"
                @keydown="handleKeyDown($event, index)" />
            </div>
            <button
              class="btn btn-primary btn-full-width"
              type="submit"
              :disabled="!isButtonActive || isLoading">
              {{
                !wrongCode
                  ? mbDictionary.otpVerifyButtonText
                  : mbDictionary.otpErrorButtonText
              }}
            </button>
            <a v-if="!wrongCode" @click="onRequestOtp">
              {{ mbDictionary.otpRequestAnchorText }}
            </a>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as lib from './../../lib/lib'
import Loader from './../components/common/Loader.vue'
import Alert from './../components/common/Alert.vue'

export default {
  components: {
    Loader,
    Alert,
  },
  props: {
    isLoading: {
      required: false,
      type: Boolean,
    },
    errorMsgs: {
      required: false,
      type: Array,
      default: null,
    },

    wrongCode: {
      required: false,
      type: Boolean,
    },
  },
  emits: ['requestOtp', 'validateOtp', 'resetOtp'],
  data() {
    return {
      otpLength: 6,
      otpCodeArray: [],
      mbDictionary: {},
    }
  },

  computed: {
    isButtonActive() {
      if (this.wrongCode) return true
      return this.otpCode.length === this.otpLength
    },

    otpCode() {
      return this.otpCodeArray.map((v) => Object.values(v)).join('')
    },
  },
  watch: {
    wrongCode() {
      if (!this.wrongCode) {
        this.otpCodeArray = []
        for (let i = 0; i < this.otpLength; i++) {
          this.$refs[`otpInput${i}`][0].classList.remove('has-value')
        }
      }
    },
  },
  mounted() {
    if (lib.getData('milesNBonusData')) {
      const { dictionary } = lib.getData('milesNBonusData')
      this.mbDictionary = dictionary
    }
  },
  methods: {
    reset() {
      this.otpCodeArray = []
      for (let i = 0; i < this.otpLength; i++) {
        this.$refs[`otpInput${i}`][0].classList.remove('has-value')
      }
      this.$emit('resetOtp')
    },

    onRequestOtp() {
      this.$emit('requestOtp')
      this.otpCodeArray = []

      document.querySelectorAll('.otp-input-field').forEach((i) => {
        i.classList.remove('has-value')
      })
    },

    onSubmitForm() {
      if (!this.wrongCode) {
        this.$emit('validateOtp', this.otpCode)
      } else {
        this.$emit('requestOtp')
      }
    },

    focusNextInput(event, index) {
      const value = event.target.value.replace(/[^\d]/g, '')
      if (!value) {
        this.otpCodeArray[index] = ''
        this.$refs[`otpInput${index}`][0].classList.remove('has-value')
        return false
      }
      if (event.target.value.length === 1 && index < this.otpLength - 1) {
        this.$refs[`otpInput${index + 1}`][0].focus()
      }
      this.$refs[`otpInput${index}`][0].classList.add('has-value')
    },

    handleKeyDown(event, index) {
      if (event.key === 'Backspace' || event.key === 'Delete') {
        if (event.target.value.length === 0 && index > 0) {
          this.$refs[`otpInput${index - 1}`][0].focus()
          this.$refs[`otpInput${index - 1}`][0].classList.remove('has-value')
        }
        this.$refs[`otpInput${index}`][0].classList.remove('has-value')
      }
    },
  },
}
</script>
